import { Route } from '@angular/router';
import {
  DefaultComponent,
  ForSaleListingPortraitComponent,
  LeaseTakeoverListingPortraitComponent,
  LocationsComponent,
  SalePendingListingPortraitComponent,
} from '@out-web/components';
import {
  ListingsComponent,
  AccountComponent,
  ModelsComponent,
  TypeComponent,
  AboutComponent,
  YourTeslaComponent,
  FaqComponent,
  TermComponent,
  PrivacyComponent,
  FraudComponent,
  ContactComponent,
  UploadImgaesComponent,
  AdsSelectComponent,
  AllLocationsComponent,
  MyListingDetailComponent,
  EditRequestComponent,
  LoginLogoutComponent,
  LocationListingsComponent,
  DealersComponent,
  SellMyTeslaComponent,
  SuccessComponent,
  FailureComponent,
  ListingDetailV2Component,
  AuthCallbackComponent,
  VisitorAgreementComponent,
  CashOfferComponent,
  AiAgentComponent
} from '@out-web/pages';
import { teslaModelMatcher } from './custom-routes';
import { HomeComponent } from '@out-web/pages';
import { authGuard } from '@out-web/core';

export const appRoutes: Route[] = [
  {
    path: 'location',
    component: LocationsComponent,
    children: [
      {
        path: ':location/used-tesla-for-sale',
        component: LocationListingsComponent,
      },
      {
        path: ':location/sell-my-tesla',
        component: LocationListingsComponent,
      },
    ],
  },
  {
    path: '',
    component: DefaultComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: 'listing/:id',
        component: ListingDetailV2Component,
      },
      {
        path: 'used-tesla-for-sale',
        component: ListingsComponent,
        data: {
          title: 'Used Tesla for Sale',
        },
      },
      {
        path: 'account',
        component: AccountComponent,
        canActivate: [authGuard],
      },
      {
        path: 'account/listing/:id',
        component: MyListingDetailComponent,
        canActivate: [authGuard],
      },
      {
        path: 'account/request-edit/listing/:id/:model/:year/:trim/:colour',
        component: EditRequestComponent,
        canActivate: [authGuard],
      },
      {
        path: 'visitor-agreement',
        component: VisitorAgreementComponent,
      },
      {
        path: 'cash-offer',
        component: CashOfferComponent,
      },
      {
        path: 'dealers',
        component: DealersComponent,
      },
      {
        path: 'contact',
        component: ContactComponent,
      },
      {
        matcher: teslaModelMatcher,
        component: ModelsComponent,
        pathMatch: 'full',
      },
      {
        path: 'about-only-used-tesla',
        component: AboutComponent,
        title: 'About',
      },
      {
        path: 'your-tesla',
        component: YourTeslaComponent,
        canActivate: [authGuard],
      },
      {
        path: 'your-tesla/edit/listing/images/:id',
        component: UploadImgaesComponent,
        canActivate: [authGuard],
      },
      {
        path: 'your-tesla/listing/checkout/:id',
        component: AdsSelectComponent,
        canActivate: [authGuard],
      },
      {
        path: 'pay/success',
        component: SuccessComponent,
      },
      {
        path: 'pay/failure',
        component: FailureComponent,
      },
      {
        path: 'chat',
        component: AiAgentComponent,
      },
      // {
      //   path: 'your-tesla/edit/listing/ads/:id',
      //   component: EditSelectedAdsComponent,
      //   canActivate: [authGuard],
      // },
      // {
      //   path: 'frequently-asked-questions',
      //   component: FaqComponent,
      //   title: 'FAQ | Sell Your Tesla | Only Used Tesla',
      // },
      {
        path: 'frequently-asked-questions',
        component: FaqComponent,
        title: 'FAQ | Sell Your Tesla | Only Used Tesla',
      },
      {
        path: 'sell-my-tesla',
        component: SellMyTeslaComponent,
      },
      {
        path: 'login',
        component: LoginLogoutComponent,
        data: {
          headText: 'Login required!',
          pageTitle: 'Login | Sell Your Tesla | Only Used Tesla',
          endText: 'to continue',
        },
      },
      {
        path: 'logout',
        component: LoginLogoutComponent,
        data: {
          headText: "You're now logged out",
          pageTitle: 'Logout | Sell Your Tesla | Only Used Tesla',
          endText: 'again to continue using account features',
        },
      },
      {
        path: 'categories/type',
        component: TypeComponent,
        children: [
          {
            path: '',
            redirectTo: 'for-sale',
            pathMatch: 'full',
          },
          {
            path: 'for-sale',
            component: ForSaleListingPortraitComponent,
          },
          {
            path: 'lease-takeover',
            component: LeaseTakeoverListingPortraitComponent,
          },
          {
            path: 'sale-pending',
            component: SalePendingListingPortraitComponent,
          },
        ],
      },
      {
        path: 'locations',
        component: AllLocationsComponent,
      },
      {
        path: 'fraud-awareness',
        component: FraudComponent,
      },
      {
        path: 'terms-and-conditions',
        component: TermComponent,
      },
      {
        path: 'our-perfect-privacy-mission',
        component: PrivacyComponent,
      },
      {
        path: '',
        redirectTo: '/',
        pathMatch: 'full',
      },
      // {
      //   path: '**',
      //   component: ErrorComponent,
      //   data: {
      //     headText: '404',
      //     pageTitle: 'Error 404 | Only Used Tesla',
      //     message: `Sorry, this page doesn't seem to exist.`,
      //   },
      // },
    ],
  },
  {
    path: 'callback',
    component: AuthCallbackComponent,
  },
];
